import React, { Component } from "react";
import Joi from "joi-browser";
import { toast, cssTransition } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import http from "../../services/HttpService";
import auth from "../../services/authService";
import config from "../../config.json";
import ToastTemplate from "../../comman/toastTemplate";
import Form from "../../comman/form";

class AddMedicine extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      selectedPartnerType: "Distributer",
      currentPage: 1,
      pageSize: 13,
      partners: [],
      manufacturer: [],
      medicationList: [],
      selectedManufactureCode: 0,
      selectedManufactureName: "",
      selectedManufactuer: 0,
      selectedDispencing: "",
      user: {},
      selectedMedicationList: [],
      selectedCenterid: 0,
    };
  }

  async componentDidMount() {
    const { currentPage, pageSize, selectedPartnerType } = this.state;
    this.loadPartners(currentPage, pageSize, selectedPartnerType);
    const { data: manufacturer } = await http.get(
      config.GetCodemanager + "CANNABIS MEDICATIONS"
    );
    console.log(manufacturer);
    this.setState({ manufacturer });

    const { data: medicationList } = await http.get(
      config.GetCodemanager + "Medications List"
    );
    console.log(medicationList);
    this.setState({ medicationList });
    const selectedMedicationList = [];
    medicationList.map((item) => {
      const mn = manufacturer.filter((x) => x.code === item.parentCode);
      const obj = {
        seleceted: false,
        manufacturer: mn[0].name,
        medicine: item.name,
        dosage: "",
        notes: "",
        id: item.id,
      };
      selectedMedicationList.push(obj);
    });
    console.log(selectedMedicationList);
    this.setState({ selectedMedicationList });
    const user = auth.getCurrentUser();
    this.setState({ currentPharmacist: user.name, user });
  }

  loadPartners = async (currentPage, pageSize, partnerType) => {
    const { data: partners } = await http.get(
      config.SetupUsers.GetPartners +
        pageSize +
        "&pageNumber=" +
        currentPage +
        "&type=" +
        partnerType
    );
    console.log(partners);
    this.setState({ partners });
  };

  doSubmit = async () => {
    console.log("Submitted");
    const {
      selectedManufactuer,
      selectedDispencing,
      user,
      selectedMedicationList,
      selectedCenterid
    } = this.state;
    const { patientInfo } = this.props;

    const mdList = selectedMedicationList.filter((x) => x.seleceted === true);

    const transaction = {
      PatienId: patientInfo.regId,
      PharmacistId: user.id,
      DispensingCenter: selectedDispencing,
      Manufacturer: selectedManufactuer,
      MedicationList: JSON.stringify(mdList),
      DispensingId:selectedCenterid
    };

    const { data: team } = await http.post(
      config.AddMedicineTransaction,
      transaction
    );
    // this.props.handleFormSubmit(team);
    this.props.handleModalShowHide();

    toast(
      <ToastTemplate
        type={"success"}
        title={"Add Medicine"}
        message={"New Medicine added successfully"}
      />
    );
  };

  handleManufactureChange = ({ currentTarget: select }) => {
    this.setState({ selectedManufactuer: select.value });
  };

  handleDispencingChange = ({ currentTarget: select }) => {
    const { partners } = this.state;
    const selectedPartner = partners.filter(
      (x) => x.fuid === parseInt(select.value)
    );
    this.setState({
      selectedDispencing: selectedPartner[0].label,
      selectedCenterid: selectedPartner[0].fuid,
    });
  };

  handleSelect = ({ currentTarget: input }) => {
    //console.log(input);
    const updatedList = [...this.state.selectedMedicationList];
    const selectedObj = this.state.selectedMedicationList.filter(
      (bc) => bc.id === parseInt(input.value)
    );
    const index = this.state.selectedMedicationList.findIndex(
      (bc) => bc.id === parseInt(input.value)
    );
    if (input.checked) {
      selectedObj[0].seleceted = true;
      updatedList[index] = selectedObj[0];
    } else {
      selectedObj[0].seleceted = false;
      updatedList[index] = selectedObj[0];
    }
    //console.log(updatedList);
    this.setState({ selectedMedicationList: updatedList });
  };

  handleDosageChange = ({ currentTarget: input }) => {
    const id = input.dataset.id;
    const updatedList = [...this.state.selectedMedicationList];
    const selectedObj = this.state.selectedMedicationList.filter(
      (bc) => bc.id === parseInt(id)
    );
    const index = this.state.selectedMedicationList.findIndex(
      (bc) => bc.id === parseInt(id)
    );
    selectedObj[0].dosage = input.value;
    updatedList[index] = selectedObj[0];
    this.setState({ selectedMedicationList: updatedList });
  };

  handleNotesChange = ({ currentTarget: input }) => {
    const id = input.dataset.id;
    const updatedList = [...this.state.selectedMedicationList];
    const selectedObj = this.state.selectedMedicationList.filter(
      (bc) => bc.id === parseInt(id)
    );
    const index = this.state.selectedMedicationList.findIndex(
      (bc) => bc.id === parseInt(id)
    );
    selectedObj[0].notes = input.value;
    updatedList[index] = selectedObj[0];
    this.setState({ selectedMedicationList: updatedList });
  };

  render() {
    const {
      partners,
      medicationList,
      manufacturer,
      selectedManufactuer,
      selectedManufactureCode,
      selectedManufactureName,
      currentPharmacist,
      selectedMedicationList,
      selectedDispencing,
      selectedCenterid,
    } = this.state;
    const { showHide, handleModalShowHide, patientInfo } = this.props;
    return (
      <Modal show={showHide} size="lg">
        <Modal.Header closeButton onClick={handleModalShowHide}>
          <Modal.Title>Medicine Dispensing Transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            <div className="col-md-6 form-group">
              <label htmlFor="patient" className="form-control-label">
                Patient Name
              </label>
              <input
                type="text"
                className="form-control"
                name="patient"
                id="patient"
                value={patientInfo.applicantName}
              />
            </div>
            <div className="col-md-6 form-group">
              <label htmlFor="patientStatus" className="form-control-label">
                Approval Status
              </label>
              <input
                type="text"
                className="form-control"
                name="patientStatus"
                id="patientStatus"
                value="Approved"
              />
            </div>
            <div className="col-md-6 form-group">
              <label htmlFor="pharmacist" className="form-control-label">
                Updated By
              </label>
              <input
                type="text"
                className="form-control"
                name="pharmacist"
                id="pharmacist"
                value={currentPharmacist}
              />
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="dispencing" className="form-control-label">
                Distributor/Dispensing Center
              </label>
              <select
                name="dispencing"
                id="dispencing"
                className="form-control"
                value={selectedCenterid}
                onChange={this.handleDispencingChange}
              >
                <option value="">Select</option>
                {partners.map((x) => (
                  <option value={x.fuid}>{x.label}</option>
                ))}
              </select>
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="manufacture" className="form-control-label">
                Select Manufacturer
              </label>
              <select
                name="manufacture"
                id="manufacture"
                className="form-control"
                value={selectedManufactuer}
                onChange={this.handleManufactureChange}
              >
                <option value="">Select</option>
                {manufacturer.map((x) => (
                  <option value={x.name}>{x.name}</option>
                ))}
              </select>
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="medicine" className="form-control-label">
                Select Cannabis Medications Prescribed
              </label>
              <div className="table-responsive">
                <table className="table align-items-center table-hover bg-white">
                  <thead className="thead-light">
                    <tr>
                      <th>Select</th>
                      <th>Manufacturer</th>
                      <th>Medicine</th>
                      <th>Dosage</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedMedicationList
                      .filter((x) => x.manufacturer === selectedManufactuer)
                      .map((m) => (
                        <tr>
                          <td>
                            <div className="custom-control custom-checkbox">
                              <input
                                className="custom-control-input"
                                id={`chk${m.id}`}
                                type="checkbox"
                                onChange={this.handleSelect}
                                checked={m.seleceted}
                                value={m.id}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`chk${m.id}`}
                              ></label>
                            </div>
                          </td>
                          <td>{m.manufacturer}</td>
                          <td>{m.medicine}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Dosage"
                              id={`dosage${m.id}`}
                              name={`dosage${m.id}`}
                              value={m.dosage}
                              onChange={this.handleDosageChange}
                              data-id={m.id}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Notes"
                              id={`notes${m.id}`}
                              name={`notes${m.id}`}
                              value={m.notes}
                              onChange={this.handleNotesChange}
                              data-id={m.id}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleModalShowHide}>
            Close
          </Button> */}
          <Button variant="outline-default" size="sm" onClick={this.doSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AddMedicine;
